import { useTheme } from '@jpmuitk/theme';
export function useListItemHeight() {
  var density = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medium';

  var _useTheme = useTheme(),
      toolkit = _useTheme.toolkit;

  return toolkit.size.getSize({
    variant: 'stackable',
    density: density
  }).height;
}